import { apiRequest, SUPABASE_URL } from "./apiUtils";

export const aiApi = {
  /**
   * Trigger AI analysis for an order document
   */
  async analyzeOrderDocument(orderId: number, orderDocumentId: number) {
    return apiRequest<any>(`${SUPABASE_URL}/ai-analyze-order-document`, {
      method: "POST",
      body: { order_id: orderId, order_document_id: orderDocumentId },
    });
  },

  /**
   * Input review + grounded suggestions for the Process screen. The review is
   * stored per order document; without `force` this returns the saved run,
   * computing one only the first time. `force: true` re-runs (resolutions of
   * unchanged items survive).
   */
  async getProcessSuggestions(
    orderId: number,
    orderDocumentId: number,
    opts?: { force?: boolean }
  ) {
    return apiRequest<any>(`${SUPABASE_URL}/ai-process-suggestions`, {
      method: "POST",
      body: {
        order_id: orderId,
        order_document_id: orderDocumentId,
        ...(opts?.force ? { force: true } : {}),
      },
    });
  },

  /**
   * Settle one review item: a suggestion (accepted/rejected) or an input
   * warning (dismissed). `null` puts it back to pending.
   */
  async resolveProcessSuggestion(
    orderDocumentId: number,
    kind: "suggestion" | "review",
    name: string,
    resolution: "accepted" | "rejected" | "dismissed" | null
  ) {
    return apiRequest<any>(`${SUPABASE_URL}/ai-process-suggestions`, {
      method: "POST",
      body: {
        action: "resolve",
        order_document_id: orderDocumentId,
        kind,
        name,
        resolution,
      },
    });
  },

  /**
   * Get existing AI analysis for an order document
   */
  async getOrderDocumentAnalysis(orderDocumentId: number) {
    return apiRequest<any>(
      `${SUPABASE_URL}/ai-analyze-order-document?order_document_id=${orderDocumentId}`
    );
  },
};
